import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { AppUser, JWTUser, SubjectsModel, TransactionListModel } from 'Model';
import { environment } from 'environments/environment';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilserviceService {
  apiurl;
  userpath;
  domainpath;
  readonly userLocalStorageKey = environment.userTokenStore;
  readonly planStoreKey = "planStore"
  req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });

  constructor(private http: HttpClient, private router: Router,private datePipe: DatePipe,) { 
    this.apiurl = environment.apiurl;
    this.userpath = "user/";
    this.domainpath = "domain/";
  }

  getDomainEnviroment(){
    const domain = location.hostname;
    let domainEnviroment = environment.domains[domain];
    if(!domainEnviroment){
      domainEnviroment = {};
    }
    return domainEnviroment;
  }

  //#region User Controller
  register(user: AppUser): Promise<JWTUser> {
    return this.http.post<JWTUser>(this.apiurl + this.userpath + `register`, user).toPromise();
  }
  login(data: any): Promise<JWTUser> {
    return this.http.post<JWTUser>(this.apiurl + this.userpath + `login`, data).toPromise();
  }
  forgotPassword(email: string)
  {
    return this.http.get(this.apiurl + this.userpath + 'forgotpassword?email=' + email).toPromise();
  } 
  resetPassword(data: any): Promise<JWTUser>{
    return this.http.post<JWTUser>(this.apiurl + this.userpath + 'resetpassword', data).toPromise();
  }
  verifyUserMail(code: string) {
    let data = {
      Code: code,
    };
    return this.http.post(this.apiurl + this.userpath + `verifyusermail`, data);
  }
  resendVerification(email: string): Promise<any> {
    return this.http.get(this.apiurl + this.userpath + `resendverification?email=` + email).toPromise();
  }

  userGoogleAuthentication(code: string): Promise<JWTUser> {
    let data = {
      "code": code
    };
    return this.http.post<any>(this.apiurl + this.userpath + `googleauth`, data, { headers: this.req_headers }).toPromise();
  }

  submitSubjects(subjects: SubjectsModel): Promise<any> {

    return this.http.post<any>(this.apiurl + this.userpath + "submitsubjects", subjects, { headers: this.req_headers }).toPromise();
  }
  //#endregion

  getsubjects(): Promise<Array<string>> {
    return this.http.get<Array<string>>(this.apiurl + this.domainpath + "getsubjects").toPromise();
  }

  getTransactionList(): Promise<Array<TransactionListModel>> {
    let user = JSON.parse(this.getCurrentUser()) as JWTUser;
    return this.http.get<Array<TransactionListModel>>(this.apiurl + this.userpath + 'transactionhistory').toPromise();
  }

  getCurrentUser() {
    return localStorage.getItem(this.userLocalStorageKey);
  }
  setAuthenticatedUserToken(user: JWTUser) {
    localStorage.removeItem(this.userLocalStorageKey);
    localStorage.setItem(this.userLocalStorageKey, JSON.stringify(user));
  }

  async receiveGoogleAuthToken(event: MessageEvent) {
    if (event.origin !== location.origin && event.data.type !== environment.googleCredVariableName) {
      return;
    }
    if (event.data.payload) {
      try {
        let user = await this.userGoogleAuthentication(event.data.payload);
        if (user.token) {
          this.setAuthenticatedUserToken(user);
          this.router.navigateByUrl("/dashboard");
        }
      } catch (error) {
        console.error("Request failed:", error);
      }
    }
  }

  activateGoogleAuthScript() {
    const scriptHolder = document.getElementById('google-script-div');
    scriptHolder.innerHTML = '';
    const script = document.createElement('script');
    script.src = `https://accounts.google.com/gsi/client`;
    scriptHolder.appendChild(script);
  }

  formatDate(date:Date){

    const value = new Date(date);

    // Convert from UTC to local time
    const localDate = new Date(value.getTime() - value.getTimezoneOffset() * 60000);
    return this.datePipe.transform(localDate, 'yyyy-MM-dd hh:mm a');
  }

  setSelectedPlan(selectedPlan) {
    localStorage.removeItem(this.planStoreKey);
    localStorage.setItem(this.planStoreKey, JSON.stringify(selectedPlan));
  }
  getSelectedPlan() {
    return JSON.parse(localStorage.getItem(this.planStoreKey));
  }
  clearSelectedPlan() {
    localStorage.removeItem(this.planStoreKey);
  }
  passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('passwordII');
  
    // Check if the passwords match
    return password && confirmPassword && password.value !== confirmPassword.value
      ? { 'passwordMismatch': true }
      : null;
  };
  removeUserAuth() {
    localStorage.removeItem(this.userLocalStorageKey);
  }

  sendContactUs(data){
    return this.http.post(this.apiurl + this.domainpath + "contactus",data).toPromise();
  }
}
